window.EMBStorage = (() => {

  const historyStack = [];

  function getEls() {

  return {

    textInput:
      document.getElementById(
        "embroideryTextInput"
      ),

    imageUploader:
      document.getElementById(
        "embroideryImageUpload"
      ),

    curvatureType:
      document.getElementById(
        "curvatureType"
      ),

    fontSelector:
      document.getElementById(
        "fontSelector"
      ),

    fontSizeSelector:
      document.getElementById(
        "fontSizeSelector"
      ),

    threadColorPicker:
      document.getElementById(
        "threadColorPicker"
      ),

    placementType:
      document.getElementById(
        "placementType"
      ),

    appliqueType:
      document.getElementById(
        "appliqueType"
      ),

    outlineEmbroidery:
      document.getElementById(
        "outlineEmbroidery"
      ),

    shadowEmbroidery:
      document.getElementById(
        "shadowEmbroidery"
      ),

    puff3d:
      document.getElementById(
        "puff3d"
      ),

    monogramStyle:
      document.getElementById(
        "monogramStyle"
      ),

    threadFinish:
      document.getElementById(
        "threadFinish"
      ),

    stitchDensity:
      document.getElementById(
        "stitchDensity"
      ),

    stitchType:
      document.getElementById(
        "stitchType"
      ),

    imageWrapper:
  document.getElementById(
    "imageLayerContainer"
  )



  };

}
  function save() {

    const els = getEls();
    
  
  const imageLayers = [];

document
.querySelectorAll(
".embroidery-image-layer"
)
.forEach(layer => {

  const img =
    layer.querySelector("img");

  imageLayers.push({

    src:
      img?.src || "",

    left:
      layer.style.left,

    top:
      layer.style.top,

    width:
      layer.style.width,

    digitizingFee:
      layer.dataset.digitizingFee || 0,

    colorCount:
      layer.dataset.colorCount || 0,

    complexity:
      layer.dataset.complexity || "Simple"

  });

});

    try {

      const textLayers = [];

document
.querySelectorAll(
".embroidery-text-layer"
)
.forEach(layer => {

  textLayers.push({

    text:
Array.from(
  layer.querySelectorAll(".curve-letter")
)
.map(letter =>
  letter.textContent.trim()
)
.filter(text =>
  text !== ""
)
.join(""),

    left:
      layer.style.left,

    top:
      layer.style.top,

    font:
getComputedStyle(
  layer.querySelector(".curve-letter")
).fontFamily,

    color:
      layer.style.color,

    fontSize:
  getComputedStyle(
    layer.querySelector(".curve-letter")
  ).fontSize,

    layerId:
      layer.dataset.layerId,

    applique:
layer.dataset.applique || "",

outline:
layer.dataset.outline || "",

shadow:
layer.dataset.shadow || "",

puff:
layer.dataset.puff || "",

monogram:
layer.dataset.monogram || "",

curve:
  layer.dataset.curve || "",

radius:
  layer.dataset.radius || "",

centerX:
  layer.dataset.centerX || "",

centerY:
  layer.dataset.centerY || ""

});

});
        const design = {

  textLayers:
    textLayers,
    imageLayers:
imageLayers,

  

        stitchType:
          els.stitchType?.value || "",

        density:
          els.stitchDensity?.value || "",

        threadFinish:
          els.threadFinish?.value || "",
          font:
els.fontSelector?.value || "",

fontSize:
els.fontSizeSelector?.value || "",


threadColor:
els.threadColorPicker?.value || "",

curvature:
els.curvatureType?.value || "",

placement:
els.placementType?.value || "",

applique:
els.appliqueType?.value || "",




        puff:
els.puff3d?.checked || false,

shadow:
els.shadowEmbroidery?.value || "",

outline:
els.outlineEmbroidery?.checked || false,

monogram:
els.monogramStyle?.value || "",

        

        



      };

      historyStack.push(
        JSON.stringify(design)
      );

      if (historyStack.length > 30) {
        historyStack.shift();
      }

      localStorage.setItem(
        "embroideryDesign",
        JSON.stringify(design)
      );

      console.log(
        "EMB design saved"
      );

    } catch(err) {

      console.error(
        "EMB save failed",
        err
      );

    }

  }

  function load() {

    const els = getEls();

    let saved = null;

    try {

      saved = JSON.parse(
        localStorage.getItem(
          "embroideryDesign"
        )
      );

    } catch(e) {

      return;

    }

    if (!saved) return;
    if(saved.textLayers){

  const textContainer =
    document.getElementById(
      "textLayerContainer"
    );

  textContainer.innerHTML = "";
  const container =
document.getElementById(
"textLayerContainer"
);

container.innerHTML = "";

  saved.textLayers.forEach(layerData => {

    const layer =
      document.createElement("div");

    layer.className =
      "embroidery-text-layer";

    layer.dataset.layerId =
      layerData.layerId;

    layer.dataset.applique =
      layerData.applique;

    layer.dataset.outline =
    layerData.outline || "";

layer.dataset.shadow =
layerData.shadow || "";

layer.dataset.puff =
layerData.puff || "";

layer.dataset.monogram =
layerData.monogram || "";
      layer.dataset.curve =
      layerData.curve;
      layer.dataset.radius =
  layerData.radius || "";

layer.dataset.centerX =
  layerData.centerX || "";

layer.dataset.centerY =
  layerData.centerY || "";

    layer.style.left =
      layerData.left;

    layer.style.top =
      layerData.top;

    layer.style.fontFamily =
      layerData.font;

    layer.style.color =
      layerData.color;

    const savedSize =
  layerData.fontSize || "32px";
      layer.dataset.fontSize =
parseInt(layerData.fontSize);

    const textContent =
      document.createElement("div");

    textContent.className =
      "text-content";

    (layerData.text || "")
.split("")
.forEach(letter => {

const span =
document.createElement("span");

span.className =
"curve-letter";

span.innerText =
letter;
span.style.fontSize = savedSize;


/* APPLIQUE */

if(layerData.applique){

  span.classList.add(
    "fabric-text"
  );

  span.classList.add(
    "fabric-" + layerData.applique
  );

}


/* OUTLINE */

if(layerData.outline){

span.classList.add(
layerData.outline +
"-outline"
);

}


/* SHADOW */

if(layerData.shadow){

span.classList.add(
layerData.shadow + "-shadow"
);

}


/* PUFF */

if(layerData.puff){

span.classList.add(
"puff-text"
);

}


/* MONOGRAM */

if(layerData.monogram){

span.classList.add(
`monogram-${layerData.monogram}`
);

}

textContent.appendChild(span);

});

    layer.appendChild(
      textContent
    );

    const handle =
      document.createElement("div");

    handle.className =
      "text-resize-handle";

    layer.appendChild(
      handle
    );

    textContainer.appendChild(
      layer
    );
    layer.addEventListener(
"click",
() => {

document
.querySelectorAll(
".embroidery-text-layer,.embroidery-image-layer"
)
.forEach(el =>
el.classList.remove(
"active-layer"
)
);

layer.classList.add(
"active-layer"
);

window.selectedEmbroideryLayer =
layer;

}
);

    if(
      typeof applyCurvature ===
      "function"
    ){
      applyCurvature(
        layer,
        parseFloat(
          layerData.curve || 0
        )
      );
    }
    

  });

}

    

if (els.fontSelector) {
  els.fontSelector.value =
    saved.font || "";
}

if (els.fontSizeSelector) {
  els.fontSizeSelector.value =
    saved.fontSize || "";
}

if (els.threadColorPicker) {
  els.threadColorPicker.value =
    saved.threadColor || "#000000";
}

if (els.curvatureType) {
  els.curvatureType.value =
    saved.curvature || "";
}

if (els.placementType) {
  els.placementType.value =
    saved.placement || "";
}

if (els.appliqueType) {
  els.appliqueType.value =
    saved.applique || "";
}

    if (
      els.stitchType
    ) {
      els.stitchType.value =
        saved.stitchType || "";
    }

    if (
      els.stitchDensity
    ) {
      els.stitchDensity.value =
        saved.density || "";
    }

    if (els.threadFinish) {
  els.threadFinish.value =
    saved.threadFinish || "";
}

if (els.puff3d) {
  els.puff3d.checked =
    saved.puff || false;
}

if (els.shadowEmbroidery) {
  els.shadowEmbroidery.checked =
    saved.shadow || false;
}

if (els.outlineEmbroidery) {
  els.outlineEmbroidery.checked =
    saved.outline || false;
}

if (els.monogramStyle) {
  els.monogramStyle.value =
    saved.monogram || "";
}

if(
saved.imageLayers &&
els.imageWrapper
){

  els.imageWrapper.innerHTML = "";

  saved.imageLayers.forEach(
    imageData => {

      const wrapper =
      document.createElement("div");

      wrapper.className =
      "embroidery-image-layer";

      wrapper.style.position =
      "absolute";

      wrapper.style.left =
      imageData.left;

      wrapper.style.top =
      imageData.top;

      wrapper.style.width =
      imageData.width;

      wrapper.dataset.digitizingFee =
      imageData.digitizingFee;

      wrapper.dataset.colorCount =
      imageData.colorCount;

      wrapper.dataset.complexity =
      imageData.complexity;

      const img =
      document.createElement("img");

      img.src =
      imageData.src;

      img.style.width =
      "100%";

      wrapper.appendChild(img);

      const handle =
      document.createElement("div");

      handle.className =
      "resize-handle";

      wrapper.appendChild(handle);

      els.imageWrapper.appendChild(
      wrapper
      );
      wrapper.addEventListener(
"click",
() => {

document
.querySelectorAll(
".embroidery-text-layer,.embroidery-image-layer"
)
.forEach(el =>
el.classList.remove(
"active-layer"
)
);

wrapper.classList.add(
"active-layer"
);

window.selectedEmbroideryLayer =
wrapper;

}
);

    }

  );

}

    console.log(
      "EMB design loaded"
    );

  }

  function undo() {

  console.log(
    "History Length:",
    historyStack.length
  );

  if (
    historyStack.length < 2
  ) return;

  historyStack.pop();

  const previous =
    JSON.parse(
      historyStack[
        historyStack.length - 1
      ]
    );

  localStorage.setItem(
    "embroideryDesign",
    JSON.stringify(previous)
  );

  load();

}

  async function saveToSupabase() {

  const design =
    JSON.parse(
      localStorage.getItem(
        "embroideryDesign"
      )
    );

  if(!design) return;

  try {

    const result =
      await window.embroiderySupabase

      .from(
        "embroidery_designs"
      )

      .insert([

        {

          design_name:
document.getElementById(
  "designName"
)?.value ||
"Untitled Design",

          design_data:
            design

        }

      ])

      .select();

    console.log(
      "SUPABASE SAVE SUCCESS",
      result
    );

  }

  catch(err){

    console.error(
      "SUPABASE SAVE ERROR",
      err
    );

  }

}
function loadDesign(designData){

  localStorage.setItem(
    "embroideryDesign",
    JSON.stringify(designData)
  );

  load();

}
return {
  save,
  load,
  undo,
  saveToSupabase,
  loadDesign
};

})();
document.addEventListener(
  "DOMContentLoaded",
  () => {

    window.EMBStorage.load();
    

    document
    .getElementById("undo-action")
    ?.addEventListener(
      "click",
      () => {

        window.EMBStorage.undo();

      }
    );

  }
);
document.addEventListener(
  "change",
  () => {

    window.EMBStorage?.save();

  }
);

document.addEventListener(
  "input",
  () => {

    window.EMBStorage?.save();

  }
);
document.addEventListener(
  "DOMContentLoaded",
  () => {

    document
    .getElementById("undo-action")
    ?.addEventListener(
      "click",
      () => {

        console.log("UNDO CLICKED");

        window.EMBStorage.undo();

      }
    );

  }
);